import { Checkbox, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { LargeButton } from "../Button/Button";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import BitcoinJourneyService, {
  AgreementType,
} from "@services/BitcoinJourney.service";
import store from "@features/store";
import { setApiMe } from "@features/action.bfapp";

type AcceptChallengeModalProps = {
  open?: boolean;
  onClose: () => void;
};

export const AcceptChallengeModal = ({
  open,
  onClose,
}: AcceptChallengeModalProps) => {
  const [checkboxes, setCheckboxes] = useState({
    agreement1: false,
    agreement2: false,
    agreement3: false,
  });

  useEffect(() => {
    setCheckboxes({
      agreement1: false,
      agreement2: false,
      agreement3: false,
    });
  }, [open]);

  const handleCheckboxChange = (e: CheckboxChangeEvent) => {
    const { id, checked } = e.target;
    setCheckboxes((prev) => ({
      ...prev,
      [id ?? "agreemnt"]: checked,
    }));
  };

  const handleSubmit = async () => {
    try {
      await BitcoinJourneyService.acceptAgreement(AgreementType.StepFive);
      store.dispatch(setApiMe(true));

      onClose();
    } catch (e) {
      console.log(e);
    }
  };

  const allChecked = Object.values(checkboxes).every((checked) => checked);

  return (
    <Modal
      className="tailwind-modal"
      open={open}
      closable
      onCancel={onClose}
      footer={null}
    >
      <div className="tailwind">
        <h5 className="text-[#24052B]">Accept challenge</h5>

        <div>
          <div className="mt-[40px]">
            <div className="mb-6">
              <Checkbox
                id="agreement1"
                checked={checkboxes.agreement1}
                onChange={handleCheckboxChange}
              >
                <label className="normal-case" htmlFor="agreement1">
                  I’ve completed all 7 modules of the Bitcoin Wealth Builder
                  Program
                </label>
              </Checkbox>
            </div>

            <div className="mb-6">
              <Checkbox
                id="agreement2"
                checked={checkboxes.agreement2}
                onChange={handleCheckboxChange}
              >
                <label className="normal-case" htmlFor="agreement2">
                  I accept the High Net Worth Bitcoin Investor Challenge
                </label>
              </Checkbox>
            </div>

            <div className="mb-6">
              <Checkbox
                id="agreement3"
                checked={checkboxes.agreement3}
                onChange={handleCheckboxChange}
              >
                <label className="normal-case" htmlFor="agreement3">
                  I commit to owning more Bitcoin every month
                </label>
              </Checkbox>
            </div>
          </div>

          <LargeButton
            disabled={!allChecked}
            onClick={handleSubmit}
            className="block mt-[40px]"
          >
            Accept
          </LargeButton>
        </div>
      </div>
    </Modal>
  );
};
